export interface RequestConfig {
  signal?: AbortSignal;
  headers?: Record<string, string | undefined>;
  params?: Record<string, unknown>;
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text' | 'stream';
}

interface UploadProgressEvent {
  loaded: number;
  total?: number;
  progress?: number;
  bytes: number;
  lengthComputable: boolean;
  upload?: boolean;
}

export interface RequestProgress {
  onUploadProgress?: (progressEvent: UploadProgressEvent) => void;
}

export interface HttpClient {
  get(
    url: string,
    config?: Omit<RequestConfig, 'responseType'> & {
      responseType: 'arraybuffer';
    } & RequestProgress
  ): Promise<Buffer>;
  get<R>(url: string, config?: RequestConfig & RequestProgress): Promise<R>;
  post<R, T = unknown>(
    url: string,
    data?: T,
    config?: RequestConfig & RequestProgress
  ): Promise<R>;
  put<R, T = unknown>(
    url: string,
    data?: T,
    config?: RequestConfig & RequestProgress
  ): Promise<R>;
  patch<R, T = unknown>(
    url: string,
    data?: T,
    config?: RequestConfig & RequestProgress
  ): Promise<R>;
  delete(url: string, config?: RequestConfig): Promise<void>;
}

export class HttpError extends Error {
  constructor(
    public override message: string,
    public status: number,
    public internalError: unknown
  ) {
    super(message);
    this.name = 'HttpError';
  }
}
